module.exports = __webpack_public_path__ + "img/arrow-down-to-bracket.c66deea6.svg";